// extracted by mini-css-extract-plugin
export default {"card":"ArticleCard_card__JFxLJ","rating":"ArticleCard_rating__5q83r","title":"ArticleCard_title__V0nwM","action":"ArticleCard_action__-BN+E","footer":"ArticleCard_footer__0+v2N"};